import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      setSent(true); // still show generic message to avoid enumeration
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFCF8] flex items-center justify-center p-8">
      <div className="w-full max-w-sm space-y-6">
        <div>
          <div className="text-xs tracking-[0.2em] uppercase text-[#5C5C5C]">Password help</div>
          <h1 className="font-display text-3xl mt-2">Forgot password</h1>
          <p className="text-sm text-[#5C5C5C] mt-2">
            Enter your account email and we&apos;ll send you a reset link (valid for 30 minutes).
          </p>
        </div>

        {sent ? (
          <div data-testid="forgot-sent" className="card-flat p-6 space-y-3">
            <div className="text-sm">
              If an account exists for <b>{email}</b>, a reset link is on its way. Check your inbox and spam folder.
            </div>
            <Link to="/login" className="text-sm text-[#2F4F4F] underline underline-offset-4">
              ← Back to sign in
            </Link>
          </div>
        ) : (
          <form data-testid="forgot-form" onSubmit={submit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                data-testid="forgot-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="h-11"
                placeholder="you@example.com"
              />
            </div>
            <Button
              data-testid="forgot-submit"
              type="submit"
              disabled={loading}
              className="w-full h-11 rounded-full bg-[#2F4F4F] hover:bg-[#213838] text-[#FDFCF8]"
            >
              {loading ? "Sending..." : "Send reset link"}
            </Button>
            <div className="text-sm text-center text-[#5C5C5C]">
              Remember it after all?{" "}
              <Link to="/login" className="text-[#2F4F4F] underline underline-offset-4">
                Sign in
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
